export const rateDetailType = {
  admin: 'admin',
  reserve: 'reserve',
  reserves: 'reserves and fees',
  commission: 'commission',
  commissions: 'commissions',
  dealerMarkUp: 'dealermarkUp'
};
